(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
function initPawProducts() {
  document.querySelectorAll('[data-paw-product]').forEach(function(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var photos = Array.from(root.querySelectorAll('.paw-photo'));
    var thumbs = Array.from(root.querySelectorAll('[data-photo-index]'));
    var active = 0;
    function showPhoto(index) {
      if (!photos.length) return;
      active = (index + photos.length) % photos.length;
      photos.forEach(function(photo,i){photo.hidden = i !== active;});
      thumbs.forEach(function(thumb,i){thumb.setAttribute('aria-pressed',String(i === active));});
    }
    thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){showPhoto(i);});});
    var prev = root.querySelector('.paw-prev'), next = root.querySelector('.paw-next');
    if(prev) prev.addEventListener('click',function(){showPhoto(active - 1);});
    if(next) next.addEventListener('click',function(){showPhoto(active + 1);});
    var select = root.querySelector('.paw-variant-select');
    function updateVariant() {
      var option = select.selectedOptions[0];
      root.querySelector('[data-paw-price]').textContent = option.dataset.price;
      var compare = root.querySelector('[data-paw-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = option.dataset.hasCompare !== 'true';
      /* bundle totals are handled by bundle-prices.js so discounts stay correct */
      var button = root.querySelector('.paw-add'), available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      var match = photos.findIndex(function(photo){return option.dataset.image && photo.dataset.imageId === option.dataset.image;});
      if(match >= 0) showPhoto(match);
    }
    select.addEventListener('change',updateVariant);
    if (new URLSearchParams(window.location.search).has('variant')) updateVariant();
  });
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initPawProducts); else initPawProducts();
document.addEventListener('shopify:section:load',initPawProducts);

  } catch(e) { console.error(e); }
})();
})();
